import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Subject, takeUntil } from 'rxjs';

import { BenefitsService } from '../../../services/benefits/benefits.service';
import { Ga4Service } from '../../../services/ga4/ga4.service';
import { ReKeyVendorInfo } from '../../../interfaces/IBenefits';
import { zipCodeRegex } from '../../../utils/constants';
import { PERKS_PAGE_VENDOR_BUTTON_NAME, SEARCH_REKEY_VENDOR } from '../../../services/ga4/ga4.constant';
import { trackByIndex } from '../../../utils/helper';

@Component({
  selector: 'app-rekey-card',
  templateUrl: './rekey-card.component.html',
  styleUrl: './rekey-card.component.scss'
})
export class ReKeyCardComponent implements OnInit, OnDestroy {
  /** Page location used for GA4 tracking (e.g. Perks & Benefits or Plan details). */
  @Input() pageLocation: string = '';
  /** Renders the mobile variant of the card (adds a `-mobile` suffix to the auto-ids). */
  @Input() isMobile: boolean = false;
  /** Base data-auto-id for the card, allowing each host page to keep a unique hook. */
  @Input() cardAutoId: string = 're-key-card';

  private cleaner$ = new Subject<void>();

  zipSearchForm!: FormGroup;
  vendorData!: ReKeyVendorInfo[];
  searchingVendor: boolean = false;
  vendorError: boolean = false;

  vendorButtonName: string = PERKS_PAGE_VENDOR_BUTTON_NAME;
  trackByIndex = trackByIndex;

  /** Base for all data-auto-ids on this card instance, suffixed for the mobile variant. */
  get autoIdBase(): string {
    return this.isMobile ? `${this.cardAutoId}-mobile` : this.cardAutoId;
  }

  constructor(
    private benefitsService: BenefitsService,
    private ga4Service: Ga4Service
  ) { }

  ngOnInit(): void {
    this.zipSearchForm = new FormGroup({
      zipCode: new FormControl('', [
        Validators.required,
        Validators.minLength(5),
        Validators.maxLength(5),
        Validators.pattern(zipCodeRegex)
      ]),
    });
  }

  ngOnDestroy(): void {
    this.cleaner$.next();
    this.cleaner$.complete();
  }

  reKeySearch(): void {
    this.searchingVendor = true;
    this.vendorError = false;
    const { zipCode } = this.zipSearchForm.value;

    this.benefitsService.reKeyZipCodeSearch(zipCode)
      .pipe(takeUntil(this.cleaner$))
      .subscribe({
        next: (response) => {
          this.ga4Service.buttonClickEvent(this.pageLocation, SEARCH_REKEY_VENDOR);
          this.searchingVendor = false;
          this.vendorData = (response.statusCode === 200) ? response.data.reKeyList : [];
        },
        error: () => {
          this.searchingVendor = false;
          this.vendorData = [];
          this.vendorError = true;
        },
      });
  }
}
